import { createInertiaApp } from "@inertiajs/react"
import { type ReactNode, createElement } from "react"
import { createRoot, hydrateRoot } from "react-dom/client"

// Temporary type definition, until @inertiajs/react provides one
interface ResolvedComponent {
  default: ReactNode & { layout?: (page: ReactNode) => ReactNode }
}

const appName = import.meta.env.VITE_APP_NAME ?? "SEOpiloto"

void createInertiaApp({
  title: (title) => (title ? `${title} - ${appName}` : appName),

  resolve: async (name) => {
    // Lazy load only marketing/auth pages
    const pages = import.meta.glob<ResolvedComponent>([
      "../pages/home/**/*.tsx",
      "../pages/landings/**/*.tsx",
      "../pages/tools/**/*.tsx",
      "../pages/legal/**/*.tsx",
      "../pages/sessions/**/*.tsx",
      "../pages/users/**/*.tsx",
      "../pages/identity/**/*.tsx",
    ])
    const importPage = pages[`../pages/${name}.tsx`]

    if (!importPage) {
      console.error(`Missing Inertia page component: '${name}.tsx'`)
      throw new Error(`Page not found: ${name}`)
    }

    const page = await importPage()

    // Marketing pages don't use persistent layout
    // Each page controls its own layout
    return page
  },

  setup({ el, App, props }) {
    if (el.hasChildNodes()) {
      hydrateRoot(el, createElement(App, props))
      return
    }
    createRoot(el).render(createElement(App, props))
  },

  progress: {
    color: "#6366f1",
  },
}).catch((error) => {
  if (typeof document !== "undefined" && document.getElementById("app")) {
    throw error
  } else if (typeof console !== "undefined") {
    console.error(
      "Missing root element.\n\n" +
        "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.",
    )
  }
})

// Theme is initialized by inline script in layout head to avoid FOUC
